<div [@scaleIn] *ngIf="visible" class="dialog">
  <div class="row nav-container">
    <div class="col-sm-12">
      <div class="row-info">


        <div class="row">
          <div class="col-md-12">
            <div class="card mx-auto d-block" id="main-card">
              <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>

              <div class="container-fluid m-t-1">
                <div class="row">
                  <div class="col-md-12">
                    <h3>{{property._source.propName}}</h3>
                    <hr>
                  </div>
                </div>

                <div class="row">

                  <div class="col-md-8">
                    <div class="col-md-12 d-flex justify-content-center" *ngIf="property._source.image_url">
                      <img src={{imageBaseUrl+property._source.image_url}} class="event_logo rounded" alt="...">
                    </div>
                  </div>

                  <!-- Application Button -->
                  <div class="col-md-4" *ngIf="userLoggedIn">
                    <div class="d-flex justify-content-center">
                      <button type="button" (click)="apply()" class="btn btn-eval btn-lg btn-teal rounded-pill">APPLY</button>
                    </div>

                  </div>
                  <!-- Ends -->

                  <div class="col-md-12 nogutters" style="padding: 0px 5px">
                    <div class="row w-100">
                      <div class="col-md-12" *ngIf="property._source.propDescription">
                        {{property._source.propDescription}}
                      </div>
                    </div>




                    <div class="jumbotron d-flex justify-content-center">
                      <div class="row w-100">
                        <div class="col" *ngIf="property._source.marketValue">
                          <div class="card border-success mx-sm-1 p-3 m-t-2">
                            <div class="card border-success shadow text-success p-3 my-card"><span class="fa fa-money"
                                aria-hidden="true"></span></div>
                            <div class="text-success text-center mt-3">
                              <p>Market Value</p>
                            </div>
                            <div class="text-success text-center mt-2">
                              <h4>{{property._source.marketValue}}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="col" *ngIf="property._source.country">
                          <div class="card border-success mx-sm-1 p-3 m-t-2">
                            <div class="card border-success shadow text-success p-3 my-card"><span class="fa fa-map-pin"
                                aria-hidden="true"></span></div>
                            <div class="text-success text-center mt-3">
                              <p>Country</p>
                            </div>
                            <div class="text-success text-center mt-2">
                              <h4>{{property._source.country}}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="col" *ngIf="property._source.province">
                          <div class="card border-success mx-sm-1 p-3 m-t-2">
                            <div class="card border-success shadow text-success p-3 my-card"><span class="fa fa-map-pin"
                                aria-hidden="true"></span></div>
                            <div class="text-success text-center mt-3">
                              <p>Province</p>
                            </div>
                            <div class="text-success text-center mt-2">
                              <h4>{{property._source.province}}</h4>
                            </div>
                          </div>
                        </div>
                        <div class="col" *ngIf="property._source.industry">
                          <div class="card border-success mx-sm-1 p-3 m-t-2">
                            <div class="card border-success shadow text-success p-3 my-card"><span
                                class="fa fa-calendar" aria-hidden="true"></span></div>
                            <div class="text-success text-center mt-3">
                              <p>Industry</p>
                            </div>
                            <div class="text-success text-center mt-2">
                              <h4>{{property._source.industry}}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="loader" [@fadeInOut]="isLoading ? 'on' : 'off'">
          <div id="loader"></div>
        </div>
      </div>

    </div>
  </div>

</div>

<!-- <app-create-quote [(visible)]="displayQuote" (success)="isQuoteSuccess($event)" [srequestObj]="srequestObj" [handymanObj]="handymanObj"></app-create-quote> -->

<div *ngIf="visible" class="overlay" (click)="close()"></div>
<app-application-form *ngIf="displayAppForm"></app-application-form>